/**
 * Luxon date formats
 * https://moment.github.io/luxon/#/formatting?id=table-of-tokens
 */
export const DATE_FORMATS = {
  /** Ex "12:34 PST" */
  SINGLE_TIME_FORMAT: 'HH:mm ZZZZ',
  /** Ex. "Thu, Jan 20" */
  SINGLE_DATE_FORMAT: 'EEE, MMM d',
  /** Ex. "Thu, Jan 20 · 12:34 PST" */
  SINGLE_DATE_TIME_FORMAT: 'EEE, MMM d · HH:mm ZZZZ',
  /** Ex "2022-01-20" */
  BE_DATE_FORMAT: 'yyyy-MM-dd',
  /** Ex "2022-01-20 13:23:00+05:00" */
  BE_DATE_TIME: 'yyyy-MM-dd HH:mm:ssZZ',
};
